import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const chatTextShimmerFn = /* @__PURE__ */ createRecipe('chatTextShimmer', {
  "active": true
}, [])

const chatTextShimmerVariantMap = {
  "active": [
    "true",
    "false"
  ]
}

const chatTextShimmerVariantKeys = Object.keys(chatTextShimmerVariantMap)

export const chatTextShimmer = /* @__PURE__ */ Object.assign(memo(chatTextShimmerFn.recipeFn), {
  __recipe__: true,
  __name__: 'chatTextShimmer',
  __getCompoundVariantCss__: chatTextShimmerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: chatTextShimmerVariantKeys,
  variantMap: chatTextShimmerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, chatTextShimmerVariantKeys)
  },
  getVariantProps: chatTextShimmerFn.getVariantProps,
})